const createPeriodsArray = (length: number) => Array.from({ length }, () => 0);

export default createPeriodsArray;
